import { render, staticRenderFns } from "./EpasnetsNotice.vue?vue&type=template&id=38725d0d&scoped=true"
import script from "./EpasnetsNotice.vue?vue&type=script&lang=js"
export * from "./EpasnetsNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38725d0d",
  null
  
)

export default component.exports